import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import commonRoutes from "./common_routes";

// hack router push callback
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// hack router replace callback
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

let dynamicRoutes = [];
// 动态加载路由
if (process.env.VUE_APP_PROJECT === "admin") {
  // 设置默认首页
  store.dispatch("setDefaultRoutePath", "/usermanage");
  // 管理员路由
  dynamicRoutes = require("@/router/admin_routes").default;
} else if (process.env.VUE_APP_PROJECT === "superadmin") {
  // 设置默认首页
  store.dispatch("setDefaultRoutePath", "/usermanage");
  // 超级管理员路由
  dynamicRoutes = require("@/router/superadmin_routes").default;
} else if (process.env.VUE_APP_PROJECT === "subjectadmin") {
  // 设置默认首页
  store.dispatch("setDefaultRoutePath", "/home");
  // 科室管理员路由
  dynamicRoutes = require("@/router/subjectadmin_routes").default;
} else {
  // 设置默认首页
  store.dispatch("setDefaultRoutePath", "/home");
  // 学员路由
  dynamicRoutes = require("@/router/normal_routes").default;
}

const routes = dynamicRoutes.concat(commonRoutes);

// 添加基本路由
store.dispatch("AddCommonRoutes", routes);

// const router = new VueRouter({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes
// });

const createRouter = () =>
  new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
  });

const router = createRouter();

// 定义一个resetRouter 方法，在退出登录时，调用即可
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
